<div>
    <form nz-form [nzLayout]="'inline'" [formGroup]="form" (ngSubmit)="onSubmit()" class="flex justify-center px-2">
        <nz-row nzGutter="16" class="w-full ">
            @for (item of srv.filterColumns; track $index) {
            @if(($index < firstLineFieldNumber || showMoreFilters)){ <nz-col  [nzMd]="$index === firstLineFieldNumber - 1 && firstLineFieldNumber === 1 ? 24 : 8" nzSm="24" nzXs="24">
                <div [ngClass]="{ '!flex !justify-between !items-end gap-2': $index === firstLineFieldNumber - 1 }" class="w-full">
                    <app-filter-field [item]="item" [fc]="getFormControl(item.key)" *ngIf="getFormControl(item.key)" />
                    @if($index === firstLineFieldNumber - 1){
                    <div class="flex justify-end items-end">
                        <button type="submit" nz-button nzType="link" (click)="showMoreFilters = !showMoreFilters" class="p-0">
                            @if(showMoreFilters){
                            <div>Less Filters
                                <span nz-icon nzType="up" nzTheme="outline"></span>
                            </div>
                            } @else {
                            <div>More Filters
                                <span nz-icon nzType="down" nzTheme="outline"></span>
                            </div>
                            }
                        </button>
                    </div>
                    }
                </div>
                </nz-col>
                }
                }
        </nz-row>
    </form>
</div>